module.exports = __webpack_public_path__ + "static/img/pay-de-btn.ee85bde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/pay/pay-de-btn.png
// module id = jwg4
// module chunks = 1